import React, { useEffect, useState } from 'react';
import UserList from '../../Components/SiteUsersItems/UserList/UsersList';
import apiClient from '../../../../../Config/apiClient';
import './SiteUsers.scss';
import { showErrorToast } from '../../../../../Context/Toaster/Toaster';
import { hasPermission } from '../../Services/permission';

const siteUserPath = process.env.REACT_APP_CC_SITE_USERS_BASE_PATH;

const SITE_USERS_SECTION = "site users";
const SITE_USERS_EDIT_KEY = ["siteusers_edit"];

const SiteUsers = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  const canEditUser = hasPermission({ section: SITE_USERS_SECTION, keys: SITE_USERS_EDIT_KEY });

  const fetchUsers = async (filteredUsers = null) => {
    if (filteredUsers) {
      setUsers(filteredUsers);
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      const response = await apiClient.post(`${siteUserPath}/list`);
      if (response.data.status === 'SUCCESS') {
        setUsers(response.data.data);
      } else {
        showErrorToast(response.data.message || 'Failed to fetch users');
      }
    } catch (err) {
      showErrorToast('Failed to fetch users');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  return <UserList users={users} loading={loading} refreshUserList={fetchUsers} canEditUser={canEditUser} />;
};

export default SiteUsers;
